
export default {

    data() {
        return {
            useCodes: false,
            calendar: null,
            holidays: [],
            office_closed_dates: [],
        }
    },

    mounted() {
        this.fetchHolidays();
        $(document).ready(() => {
            this.onReady();
        })
    },

    methods: {

        onReady() {

            var self = this;
            var calendarEl = document.getElementById('schedule-calendar');

            this.calendar = new FullCalendar.Calendar(calendarEl, {
                eventTimeFormat: {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                },
                customButtons: {
                    goToDateButton: {
                        text: 'Date',
                        click(){
                            self.openModal('select-specific-date-to-go-modal')
                        }
                    }
                },
                headerToolbar: {
                    left: 'title',
                    center: '',
                    right: (this.authorize('admin') ? 'goToDateButton,' : '') + 'today,prev,next'
                },
                initialView: 'dayGridMonth',
                events: this.fetchSchedules,
                eventClick: (click => {
                    if (click.event.extendedProps.schedule) {
                        this.onEventClick(click.event, click.jsEvent, click.view)
                    }
                }),
            });

            this.calendar.render();
            this.calendar.setOption('locale', config.locale);
        },

        fetchClosedDays: async function () {
            var response = await App.request().get(`/api/schedules/office-closed`);
            this.office_closed_dates = []

            response.data.forEach(item => {
                this.office_closed_dates.push({
                    id: item.id,
                    title: 'Office Closed',
                    start: moment(item.from).format(),
                    display: 'block',
                    end: moment(item.to).format(),
                    backgroundColor: '#e50a0a',
                    borderColor: '#fff',
                    textColor: '#ffffff'
                })
            })
        },

        fetchHolidays: async function () {
            var response = await axios.get(`https://www.googleapis.com/calendar/v3/calendars/en.usa%23holiday%40group.v.calendar.google.com/events?key=${App.config.googleKey}`);
            response.data.items.forEach(item => {
                this.holidays.push({
                    id: item.id,
                    title: item.summary,
                    start: moment(item.start.date).format(),
                    display: 'block',
                    end: moment(item.end.date).format(),
                    backgroundColor: '#afe2ff',
                    borderColor: '#fff',
                    textColor: '#33596e'
                })
            })
        },

        fetchSchedules(start, end, timezone, callback) {
            // Implement this on one on the parent component.
            callback([])
        },

        onEventClick(event, jsEvent, view) {
            // custimoized by the component
        },

        mapSchedules(schedules) {
            var events = [];
            schedules.forEach(schedule => {
                if (Array.isArray(schedule.days)) {
                    _.each(schedule.days, (day, index) => {
                        schedule['date'] = day;
                        events.push(this.parseEvent(schedule, (index > 0)))
                    });
                } else {
                    events.push(this.parseEvent(schedule))
                }
            });
            return events.concat(this.holidays).concat(this.office_closed_dates)
        },

        parseEvent(schedule, isExtension = false) {

            var course = schedule.schedulable;

            var event = {
                // Time
                id: schedule.id,
                start: moment(schedule.date).format(),

                // Data
                title: this.resolveTitle(schedule),
                display: isExtension ? '' : 'block',
                extendedProps:{
                    schedule: schedule,
                }
            };

            var style = this.getStyle(schedule);

            return {...event, ...style};
        },


        resolveTitle(schedule){
            if(this.useCodes) {
                if (this.isTrainingQuarterSpanish(schedule)) {
                    return 'TQ-' + schedule.schedulable.id;
                }

                return schedule.schedulable.code
            }
            return schedule.schedulable.title;
        },

        getStyle(schedule) {

            if(schedule.is_cancelled){
                return {
                    borderColor: '#dc2d3e',
                    backgroundColor: '#dc2d3e',
                    textColor: '#fff'
                }
            }

            if(schedule.is_archived){
                return {
                    borderColor: '#353d41',
                    backgroundColor: '#353d41',
                    textColor: '#fff'
                }
            }

            // save as not published
            if(!schedule.active){
                return {
                    borderColor: '#ffb02a',
                    backgroundColor: '#ffb02a',
                    textColor: '#222'
                }
            }

            if (this.isTrainingQuarterSpanish(schedule)) {
                return {
                    borderColor: '#5F91BA',
                    backgroundColor: '#5F91BA',
                    textColor: '#fff'
                }
            }

            if (this.isLabSpanish(schedule)) {
                return {
                    borderColor: '#8D2424',
                    backgroundColor: '#8D2424',
                    textColor: '#fff'
                }
            }

            if (this.isLabEnglish(schedule)) {
                return {
                    borderColor: '#A88D2E',
                    backgroundColor: '#A88D2E',
                    textColor: '#fff'
                }
            }
        },

        isLabSpanish(schedule) {
            console.log(schedule)
            return schedule.schedulable_type == 'App\\Models\\Course' && schedule.schedulable.type.includes('lab') && schedule.lang == 'Spanish';
        },

        isLabEnglish(schedule) {
            return schedule.schedulable_type == 'App\\Models\\Course' && schedule.schedulable.type.includes('lab') && schedule.lang == 'English';
        },

        isTrainingQuarterSpanish(schedule) {
            return schedule.schedulable_type == 'App\\Models\\TrainingQuarter'; //&& schedule.lang == 'Spanish'
        }
    }
}
